<template>
  <text-review-popup
    :visible="visible"
    :title="$t('registration.client.info.terms.of.use')"
    @close="toggleAgreementDataPopup"
  >
    <template slot="message">
      <paragraph-list :headers="popupHeaders" :paragraphs="popupParagraphs" />
    </template>
  </text-review-popup>
</template>

<script>
import ParagraphList from '@/components/common/ParagraphList.vue';
import TextReviewPopup from '@/components/popup/TextReviewPopup.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'TermsOfUsePopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: {
    ParagraphList,
    TextReviewPopup,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    popupHeaders() {
      return [
        this.$t('terms.of.use.header.title'),
        this.$t('terms.of.use.acceptance.of.agreement.title'),
        this.$t('terms.of.use.copyright.title'),
        this.$t('terms.of.use.imited.license.title'),
        this.$t('terms.of.use.restrictions.and.prohibitions.title'),
        this.$t('terms.of.use.info.purpose.only.title'),
        this.$t('terms.of.use.linking.to.the.site.title'),
        this.$t('terms.of.use.errors.corrections.changes.title'),
        this.$t('terms.of.use.third.party.content.title'),
        this.$t('terms.of.use.unlawful.activity.title'),
        this.$t('terms.of.use.indemnification.title'),
        this.$t('terms.of.use.disclaimer.title'),
        this.$t('terms.of.use.limitation.of.liability.title'),
        this.$t('terms.of.use.use.of.information.title'),
        this.$t('terms.of.use.links.to.other.web.sites.title'),
        this.$t('terms.of.use.copyrights.title'),
        this.$t('terms.of.use.legal.compliance.title'),
        this.$t('terms.of.use.miscellaneous.title'),
        this.$t('terms.of.use.arbitration.title'),
      ];
    },
    popupParagraphs() {
      return [
        this.$t('terms.of.use.header.message'),
        this.$t('terms.of.use.acceptance.of.agreement.message'),
        this.$t('terms.of.use.copyright.message'),
        this.$t('terms.of.use.imited.license.message'),
        this.$t('terms.of.use.restrictions.and.prohibitions.message'),
        this.$t('terms.of.use.info.purpose.only.message'),
        this.$t('terms.of.use.linking.to.the.site.message'),
        this.$t('terms.of.use.errors.corrections.changes.message'),
        this.$t('terms.of.use.third.party.content.message'),
        this.$t('terms.of.use.unlawful.activity.message'),
        this.$t('terms.of.use.indemnification.message'),
        this.$t('terms.of.use.disclaimer.message'),
        this.$t('terms.of.use.limitation.of.liability.message'),
        this.$t('terms.of.use.use.of.information.message'),
        this.$t('terms.of.use.links.to.other.web.sites.message'),
        this.$t('terms.of.use.copyrights.message'),
        this.$t('terms.of.use.legal.compliance.message'),
        this.$t('terms.of.use.miscellaneous.message'),
        this.$t('terms.of.use.arbitration.message'),
      ];
    },
  },
  methods: {
    toggleAgreementDataPopup() {
      this.$emit('closed');
    },
  },
};
</script>
